module.exports = __webpack_public_path__ + "static/media/famille_livia_P3Dl5XY.3900ff9a.jpg";